import { render, staticRenderFns } from "./ObjectsHeader.vue?vue&type=template&id=f5d8d452&"
import script from "./ObjectsHeader.vue?vue&type=script&lang=js&"
export * from "./ObjectsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports